<div class="ion-card gigs" *ngIf="gig">
  <div class="ion-card-header">
    <div class="ion-float-right">
      <div class="ion-fab-button fab-button-small">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88.82 66.6"><path d="M82,29.07a4.3,4.3,0,1,0-6.08,6.08A12.5,12.5,0,0,1,58.22,52.83l-8-8L59.06,36a21.09,21.09,0,0,0,0-29.82h0A20.92,20.92,0,0,0,44.17,0h0A20.92,20.92,0,0,0,29.23,6.18c-.08.08-.14.17-.21.25A21.11,21.11,0,0,0,29.27,36l6.94,6.89,6-6.11-6.93-6.87a12.49,12.49,0,1,1,17.65,0l-22.9,22.9A12.5,12.5,0,0,1,12.41,35.15a4.3,4.3,0,1,0-6.08-6.08A21.09,21.09,0,1,0,36.16,58.9l8-8,8,8A21.09,21.09,0,0,0,82,29.07Z"/></svg>
      </div>
    </div>
    <div class="ion-card-title" *ngIf="gig.title">{{gig.title}}</div>
  </div>
  <div class="ion-card-content">
    <div class="ion-card-subtitle">
      <span *ngIf="gig.location != 'remote'" class="location ion-padding-end">
        <img *ngIf="gig.country" class="ion-icon" src="/assets/flags/{{gig.country | lowercase}}.svg" alt="{{gig.country}}" width="20" height="16" loading="lazy" />
        <img *ngIf="!gig.country" class="ion-icon" src="/assets/icons/globe.svg" alt="Global" width="16" height="16" loading="lazy" />
        <ng-container *ngIf="gig.suburb || gig.city">{{gig.suburb}} {{gig.city}}</ng-container>
        <ng-container *ngIf="!(gig.suburb || gig.city) && directory_data">{{directory_data.name}}</ng-container>
      </span>
      <span *ngIf="gig.location == 'remote'" class="location ion-padding-end">
        <img class="ion-icon" src="/assets/icons/globe.svg" alt="Remote" width="16" height="16" loading="lazy" />
        Remote
      </span>
      <span *ngIf="gig.alias" class="alias ion-hide-sm-down ion-padding-end">
        <img class="ion-icon" src="/assets/icons/star.svg" alt="Star" width="16" height="16" loading="lazy" />
        {{gig.alias}}
      </span>
    </div>
    <p class="ion-padding" *ngIf="gig.overview">{{gig.overview}}</p>
    <a [href]="'/gigs/detail/'+gig.slug">
      <button class="button-round button-tertiary">{{gig.total | currency : (gig.currency | uppercase) : 'symbol' : '1.0-0' }}</button>
    </a>
  </div>
</div>
